import { render, staticRenderFns } from "./DanhGiaNDDDuLieuBaoCao.vue?vue&type=template&id=2ae938ce&scoped=true"
import script from "./DanhGiaNDDDuLieuBaoCao.vue?vue&type=script&lang=ts"
export * from "./DanhGiaNDDDuLieuBaoCao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae938ce",
  null
  
)

export default component.exports